module.exports = __webpack_public_path__ + "static/media/iconClose.ce2faf2c.svg";